import { useTranslation } from 'react-i18next'
import { Box, Button, CircularProgress, Container, TextField } from '@mui/material';
import { Variants, motion } from "framer-motion"
import { Typography } from '@mui/material';
import { useState } from 'react';
import Map from './Map';

function Contact() {
    const { t } = useTranslation();
    const [load] = useState(false);


    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    return (
        <div  >
            {/* <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre45'} lien={'Label.Titre.titre13'} /> */}
            {/* <br /><br /><br /><br /><br /><br /><br /><br />
            <br />
            <br /> */}

            <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.8 }}
                variants={scroll}
                className='produitsEtServices'
            >
                {/* <Container maxWidth='md'>
                    <Box display={"flex"} >
                        <center>
                            <img className='move' style={{ borderRadius: "5%" }} width={"20%"} src={require("../Database/Files/Contactez nous/1 9466812.png")} alt="" />
                        </center>
                    </Box>
                </Container> */}

            </motion.div>

            {/* <br /><br />


            <Container maxWidth='lg'>
                <Box className='boxCS warning' padding={2} borderRadius={3}>
                    <>
                        <Warning fontSize='large' color='warning' />
                    </>
                    <>
                        <Typography>{t("SOUS_TITRE.CandidatureSpontanee")}</Typography>
                        <br />
                        <motion.button
                            onClick={postules}
                            whileHover={{
                                scale: 1.2,
                                transition: { duration: 1 },
                            }}
                            whileTap={{ scale: 0.9 }}
                            className='btn'>{t("Bouton.Condidaturespontanee")}
                        </motion.button>
                    </>
                </Box>
            </Container>
            <br /><br /> */}

            <Box display={"flex"}>
                {/* <Box display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseGauche} alt="" />
                </Box> */}

                <Container maxWidth='lg'>
                    <Box gap={5} display={{ xs: 'block', sm: 'flex' }} >
                        {/* <Box className='resume' borderRadius={3}>

                            <Box>
                                <Typography padding={"5%"} fontWeight={"bold"} variant='h5'>{t("Label.Titre.titre47")}</Typography>
                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><LocationOn /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("Label.Titre.titre27")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.siege")}, {t("ENTETE.ville")}</label>
                                    </Box>
                                </Box>

                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><PhoneAndroid /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("ENTETE.telephone")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.numero")}</label>
                                    </Box>
                                </Box>

                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><Mail /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("ENTETE.email")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.email_value")}</label>
                                    </Box>
                                </Box>
                                <hr />

                                <Typography padding={"5%"} fontWeight={"bold"} variant='h5'>{t("Label.Titre.titre48")}</Typography>
                                <Box padding={"5%"} gap={1} display={"flex"}>
                                    <IconButton style={{ border: "1px solid" }} ><LinkedIn /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} color='error'><Instagram /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} ><Facebook /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} color='error'><Mail /></IconButton>
                                </Box>
                            </Box>

                        </Box>
                        <hr style={{ visibility: 'hidden' }} /> */}
                        <Box width={{ xs: '100%', sm: '70%' }} className='CantactForm'>

                            {/* <Spin spinning={load}>

                                
                            </Spin> */}
                            {/* onSubmit={handleSubmit(SendMail)} */}
                            <Typography fontWeight={"bold"} variant='h5'>{(t("Label.Titre.titre1")).toUpperCase()}</Typography>
                            <label className='textgray'>{t("Label.Titre.titre2")}</label><br /><br />
                            <form style={{ backgroundColor: "white", borderRadius: "5%", padding: "5%" }} >
                                <Box >
                                    <Box>
                                        <Box gap={2} display={"flex"}>
                                            <TextField
                                                // {...register("tel", { required: true })}

                                                id="outlined-basic"
                                                label={t("Label.Titre.titre3")}
                                                type={"tel"} variant="outlined"

                                                fullWidth
                                                size='small'
                                            />
                                            <TextField
                                                // {...register("email", { required: true })}

                                                id="outlined-basic"
                                                label={t("Label.Titre.titre4")}
                                                type={"email"} variant="outlined"
                                                fullWidth
                                                size='small'
                                            />
                                        </Box><br />
                                        <TextField
                                            // {...register("ville", { required: true })}

                                            id="outlined-basic"
                                            label={t("Label.Titre.titre5")}
                                            type={"text"} variant="outlined"
                                            fullWidth
                                            size='small'
                                        />
                                        <br /><br />
                                        <TextField
                                            // {...register("sujet", { required: true })}

                                            id="outlined-basic"
                                            label={t("Label.Titre.titre6")}
                                            type={"text"} variant="outlined"
                                            fullWidth
                                            size='small'
                                        />
                                        <br /><br />
                                        <TextField
                                            // {...register("message", { required: true })}

                                            id="outlined-basic"
                                            label={t("Label.Titre.titre7")}
                                            type={"text"} variant="outlined"
                                            multiline
                                            rows={3}
                                            fullWidth
                                            size='small'
                                        />
                                    </Box>
                                    <hr style={{ visibility: "hidden" }} />
                                    {/* <Box>
                                        <UploadFile text={'Cliquez ou clissez un fichier ici'} />
                                    </Box> */}
                                </Box>
                                <br />
                                <Button
                                    size='large'
                                    variant='contained'
                                    fullWidth

                                    style={{ backgroundColor: "#0cc0df" }}
                                    disabled={load}

                                    endIcon={
                                        load ? <CircularProgress size={"20px"} color='inherit' /> : ""
                                    }
                                    className='btn-submit'
                                    type='submit'
                                >{t("Label.Titre.titre8")}</Button>
                            </form>
                        </Box><br />
                        <Box width={"100%"}>
                            <Typography fontWeight={"bold"} variant='h5'>{t("contenu.texte12").toUpperCase()}</Typography>
                            <label className='textgray'>{t("contenu.texte13")}</label><br /><br />

                            <Map />
                        </Box>
                    </Box>
                </Container>
                {/* <Box display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseDroite} alt="" />
                </Box> */}
            </Box>
        </div>
    )
}
export default Contact